// 导入各个数据模块
import { products } from './products';
import { crystalTypes } from './crystalTypes';
import { showcases } from './showcases';
import { zodiac as zodiacData } from './zodiac';

// 首饰类别
export const jewelryCategories = [
  { id: 1, name: '项链' },
  { id: 2, name: '手链' },
  { id: 3, name: '耳环' },
  { id: 4, name: '戒指' },
  { id: 5, name: '吊坠' },
  { id: 6, name: '原石' },
  { id: 7, name: '套装' }
];

// 轮播图数据
export const carouselItems = [
  {
    id: 1,
    imageUrl: process.env.PUBLIC_URL + '/assets/images/products/natural_amethyst_crystal_cluster_on_white_background_4961656b.webp',
    title: '紫水晶系列',
    description: '探索紫水晶的神秘能量，提升灵性与直觉',
    productId: 1,
    buttonText: '立即查看'
  },
  {
    id: 2,
    imageUrl: process.env.PUBLIC_URL + '/assets/images/products/elegant_rose_quartz_bracelet_on_white_background_c0604e42.webp',
    title: '粉晶爱情系列',
    description: '粉晶，爱的能量石，促进自爱与人际和谐',
    productId: 2,
    buttonText: '立即查看'
  },
  {
    id: 3,
    imageUrl: process.env.PUBLIC_URL + '/assets/images/products/natural_citrine_crystal_piece_on_white_background_2aa1081e.webp',
    title: '能量计算器',
    description: '发现适合你的水晶，平衡五行能量',
    link: '/energy-calculator',
    buttonText: '开始测算'
  }
];

// 导出所有数据
export { products, crystalTypes, showcases, zodiacData };

// 产品详情（包含更多信息的产品数据）
export const productDetails = products.map(product => ({
  ...product,
  // 确保每个产品至少有一个图片
  images: product.images && product.images.length > 0 
    ? product.images 
    : [product.imageUrl]
}));